<template>
  <div class="ocr">
    <section class="content">
      <section class="title">{{labelValue}}
      </section>
      <section class="tips">
        {{nameValue}}
      </section>
      <div class="tips-content tips" v-html="contentValue">
      </div>
      <u class="help" @click="navigateTo('/authentication/id/guide')">身份证识别遇到问题</u>
      <section class="picture">
        <div class="item">
          <img :src="frontImg" />
          <input
            ref="frontInput"
            type="file"
            accept="image/*"
            capture="camera"
            class="frontInput"
            @change="changeHandler($event, 'CARD_FRONT_PHOTO')"
          />
          <span class="text" v-show="!frontCoverVisible">
            请拍摄人像面
          </span>
        </div>
        <div class="item">
          <img :src="backImg" />
          <input
            ref="backInput"
            type="file"
            accept="image/*"
            class="backInput"
            capture="camera"
            @change="changeHandler($event, 'CARD_BACK_PHOTO')"
          />
          <span class="text" v-show="!backCoverVisible">
            请拍摄国徽面
          </span>
        </div>
      </section>
      <section class="id-card-info" v-show="infoVisible">
        <div class="tip">
          *请确认您的信息，若有误请点击修改
        </div>
        <div class="id-card-info-item">
          <span class="label">真实姓名</span><nd-input v-model="name" @input="nameInput"></nd-input>
        </div>
        <div class="line"></div>
        <div class="id-card-info-item">
          <span class="label">身份证号</span><nd-input v-model="idcardNumber" @input="idcardInput" maxLength="18"></nd-input>
        </div>
        <div class="line"></div>
        <div class="line"></div>
      </section>
      <section class="error-info" v-show="errorInfoVisible">
        {{ errorInfo }}
      </section>
    </section>

    <nd-button
      class="next-step"
      :disabled="disabled"
      v-if="$route.query.stepType==='OCR'"
      @click="next"
    >下一步</nd-button>
 
    <canvas id="canvas" v-show="false" width="1440" height="1080"></canvas>
    
  </div>
</template>

<script>

import pic01 from '@/view/authentication/images/img_zheng@2x.png'
import pic02 from '@/view/authentication/images/img_fan@2x.png'
import ImageCompressor from 'image-compressor.js'
import { mapActions, mapState } from 'vuex'
import { getKey } from '../../../../assets/utils'
import { Toast } from 'vant'
let timer = null
function debounce (fn, wait) {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  timer = setTimeout(function () {
    fn()
  }, wait)
}

export default {
  name: 'authentication-id',
  components: {
    Toast
  },
  customReadyNotify: true,
  props: {
    status: {
      type: String,
      default: 'unEnter'
    }
    
  },

  data () {
    return {
      frontImg: pic01,
      frontFile: '',
      backImg: pic02,
      backFile: '',
      successed: false,
      infoVisible: !false, // 身份信息可见性
      errorInfoVisible: false, // 错误信息可见性
      errorInfo: '',
      frontCoverVisible: false,
      backCoverVisible: false,
      detentionVisible: false,
      activityVisible: false,
      activityTempleVisible: false,
      pfrom: this.$route.query.pfrom,
      currentActivity: {},
      giveUpReason: [
        '放弃免费额度',
        '操作不便，不想继续',
        '手边资料不全，无法完成'
      ], 
      name: null,
      idcardNumber: null,
      address: null,
      orderNo: null,
      popupList: [],
      CONTENT: {
        'unEnter': { 
          key: 0, 
          labelValue: '身份信息',
          contentValue: '仅用于身份审核，拍摄时请确保身份证边框完整、字迹清晰。' },
        'ocr': { 
          key: 0, 
          labelValue: '身份信息缺失补充',
          nameValue: '您当前身份信息',
          contentValue: '为保障您的信息安全，需您重新提交证件信息进行身份核实。 拍摄时请确保身份证边框完整、字迹清晰。' },
        'aboutToExpire': { 
          key: 1,
          labelValue: '身份信息更新', 
          nameValue: `您的证件即将失效，请核实您的身份证有效期。`,
          contentValue: '为保障您的信息安全，请办理更新后重新上传有效身份证件， 进行身份验证。<br/>拍摄时请确保身份证边框完整、字迹清晰。' },
        'expired': { 
          key: 1,
          labelValue: '身份信息更新', 
          nameValue: `您的证件已失效，请核实您的身份证有效期。`,
          contentValue: '为保障您的信息安全，请办理更新后重新上传有效身份证件， 进行身份验证。<br/>拍摄时请确保身份证边框完整、字迹清晰。' }
      }
    }
  },

  computed: {
    ...mapState({
      caseList: state => state.caseList
    }),
    ...mapState('user', {
      quotaInfo: state => state.quotaInfo
    }),
    authStatus () {
      return getKey('userInfo').authStatus || []
    },

    disabled () {
      return !this.checkName() || !this.checkIDCard() || !this.checkAddress()
    },
    labelValue () {
      return this.CONTENT[this.status].labelValue
    },
    nameValue () {
      return this.CONTENT[this.status].nameValue
    },
    contentValue () {
      return this.CONTENT[this.status].contentValue
    }
  },

  watch: {
    // 是否照了正面
    frontFile (value) {
      if (value && this.backFile) {
        this.IDOCR()
      }
    },
    // 是否照了背面
    backFile (value) {
      if (value && this.frontFile) {
        this.IDOCR()
      }
    },

    activityVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_supplementaryOCR',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    },

    activityTempleVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_supplementaryOCR',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    }
  },

  async created () {
    await Promise.all([this.getCaseListX({ loanPlatform: 'TMD', step: 'OCR' })])
    this.$bus.$emit('ready')
  },

  methods: {
    ...mapActions('authentication', ['TXOCRX', 'uploadOSS']),
    ...mapActions('apiDiversion', ['ocrVerify']),
    ...mapActions(['getCaseListX']),
    changeHandler (event, type) {
      // 此时可以自行将文件上传至服务器
      const file = event.target.files[0]
      if (file) {
        this.$indicator()
        this.compressor(file).then(async (newFile) => {
          const base64File = await this.getImgBase64(newFile)
          const params = {
            base64Str: base64File, fileType: type
          }
          this.uploadOSS(params).then((response) => {
            this.$indicator.close()
            if (response.success) {
              if (type === 'CARD_FRONT_PHOTO') {
                this.frontImg = URL.createObjectURL(file)
                this.frontFile = response.data
                this.frontCoverVisible = true
                this.errorInfoVisible = false
              } else {
                this.backImg = URL.createObjectURL(file)
                this.backFile = response.data
                this.backCoverVisible = true
                this.errorInfoVisible = false
              }
            } else {
              this.$message('上传身份证文件失败')
            }
          })
        })
      }
    },
    // 图片压缩
    compressor (file, quality = 0.8) {
      var _this = this
      return new Promise((resolve) => {
        return new ImageCompressor(file, {
          quality: quality,
          maxWidth: 1440,
          maxHeight: 1080,
          success (result) {
            if (result.size > 2 * 1000 * 1000) {
              _this.compressor(file, quality - 0.2)
            } else {
              resolve(result)
            }
          }
        })
      })
    },
    // 图片转化为base64
    getImgBase64 (file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          let file = this.result.replace('data:image/jpeg;base64,', '')
          resolve(file)
        }
      })
    },
    // 置空
    empty () {
      this.name = null
      this.idcardNumber = null
      this.address = null
      this.orderNo = null
      this.infoVisible = false
      this.errorInfoVisible = false
      this.errorInfo = ''
    },
    // OCR识别
    async IDOCR () {
      this.empty()
      this.$indicator('认证中')
      const params = {
        idcardFrontUrl: this.frontFile,
        idcardBackUrl: this.backFile
      }
      const response = await this.TXOCRX(params)
      this.$indicator.close()
      if (response.success) {
        if (!response.data.bizCode || response.data.bizCode === '000000') {
          // 只有身份信息识别成功才回显身份信息
          this.name = response.data.name
          this.idcardNumber = response.data.idcard
          this.address = response.data.address
          this.orderNo = response.data.orderNo
          this.infoVisible = true
        } else {
          // 识别不成功
          this.errorInfo = response.data.bizMsg 
          this.errorInfoVisible = true
        }
      }
    },
    // 放弃激活额度
    giveUp (index) {
      this.$report({
        id: 10078,
        args: {
          target: index,
          position: 'page_auth_supplementaryOCR'
        }
      })
      if (this.pfrom === 'landing') {
        // this.navigateTo('/landing/index')
        this.$router.back()
      } else {
        this.detentionVisible = false
        this.$nextTick(() => {
          const { source } = this.$route.query || {}
          if (source === 'XIESHANG') {
            this.$router.go(-1)
          } else {
            this.navigateTo('/')
          }
        })
      }
    },

    // 用户挽留政策
    detention () {
      this.$report({
        id: 10076,
        position: 'page_auth_supplementaryOCR'
      })
      this.popupList = this.caseList.filter(item => item.showType === 'POPUP' && item.showAction === 'EXIT' && item.step === 'OCR').sort((a, b) => b.sort - a.sort)
      this.detentionStep()
    },

    // 开始判断
    detentionStep () {
      if (this.popupList.length > 0) {
        this.currentActivity = this.popupList.shift()
        console.log(this.currentActivity)
        if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
          this.activityTempleVisible = true
        } else {
          this.activityVisible = true
        }
      } else {
        this.detentionVisible = true
      }
    },

    // 继续完成
    neverGiveup () {
      this.detentionVisible = false
      this.$report({
        id: 10078,
        args: {
          target: 0,
          position: 'page_auth_supplementaryOCR'
        }
      })
    },
 
 

    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    nameInput () {
      debounce(() => {
        this.checkName(true)
      }, 500)
    },
    idcardInput () {
      debounce(() => {
        this.checkIDCard(true)
      }, 500)
    },
    addressInput () {
      debounce(() => {
        this.checkAddress(true)
      }, 500)
    },
    checkName (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.name) return false
      // if (/^[\u4e00-\u9fa5]{2,20}$/.test(this.name)) {
      if (this.name.length >= 2) {
        this.errorInfo = null
        this.errorInfoVisible = false

        return true
      } else {
        if (showError) {
          this.errorInfo = '姓名格式错误，请重新输入'
          this.errorInfoVisible = true
        }
        return false
      }
    },

    checkIDCard (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.idcardNumber) return false
      // if (this.idcardNumber.length === 18) {
      if (this.idcardNumber.length > 0) {
        this.errorInfo = null
        this.errorInfoVisible = false

        return true
      } else {
        if (showError) {
          this.errorInfo = '身份证格式错误，请重新输入'
          this.errorInfoVisible = true
        }
        return false
      }
    },
    checkAddress (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.address) return false
      // if (this.address.length > 4 && /[\u4e00-\u9fa5]/.test(this.address) && !isEmojiCharacter(this.address)) {
      if (this.address.length > 0) {
        this.errorInfo = null
        this.errorInfoVisible = false

        return true
      } else {
        if (showError) {
          this.errorInfo = '证件地址格式错误，请重新输入'
          this.errorInfoVisible = true
        }
        return false
      }
    },
  
    async next () {
      if (this.$route.query.stepType === 'OCR') {
        const configIds = getKey('configIds')
        this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', product_code: JSON.stringify(configIds), page_status: JSON.stringify(this.authStatus) })
      }
      // 三要素
      if (!this.successed) {
        return new Promise(async (resolve, reject) => {
          if (this.disabled) {
            this.$message('请完善身份信息')
            reject(new Error('请完善身份信息'))
            return
          }
          const res = await this.ocrVerify({
            configId: getKey('configIds')[0],
            orderNo: this.orderNo,
            idCard: this.idcardNumber,
            name: this.name,
            address: this.address,
            isUpdate: this.status !== 'unEnter' 
          })
     
          if (res.success) {
            this.successed = true
            if (this.$route.query.stepType === 'OCR') {
              return this.$router.replace('/authentication/api-auth')
            }
            resolve()
          } else {
            reject(new Error(res.message))
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../../assets/less/mixin.less";

@black-33: #333333;
@black-99: #999999;
.ocr {
 
    background-color: #fafafa;
  
    .content {
        // flex: 1;
        padding: 44px 0px 0;
        background-color: #fafafa;

        .title {
            padding: 0px 40px;
            display: flex;
            align-items: flex-end;
            font-size: 46px;
            font-weight: 500;
            line-height: 1;
            font-family: PingFangSC-Medium;
            > img {
                width: 56px;
                height: 43px;
                margin-right: 20px;
            }
        }

        .tips {
            padding: 0px 40px;
            margin-top: 20px;
            font-size: 26px;
            color: @black-33;
        }
        .tips-content{
            margin:0;
            font-size: 28px;
            color: @black-99;
        }
        .picture {
            padding: 0px 40px;
            display: flex;
            justify-content: space-between;
            .item {
                position: relative;
                width: 320px;
                height: 280px;
                > input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 210px;
                    opacity: 0;
                }
                > img {
                    display: block;
                    width: 100%;
                    height: 210px;
                    border-radius: 10px;
                    object-fit: cover;
                }

                .text {
                    position: absolute;
                    left: 50%;
                    bottom: 1px;
                    transform: translateX(-50%);
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 48px;
                    text-align: center;
                }
            }
        }

        .id-card-info {
            font-size: 30px;
            line-height: 54px;
            color: @black-33;
            font-weight: 400;
            margin-top: 40px;
            font-family: PingFangSC-Regular;
            .tip {
                padding: 0px 40px;
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                padding-bottom: 10px;
                color: #999999;
                line-height: 30px;
            }
            .id-card-info-item {
                height: 90px;
                display: flex;
                align-items: center;
                background-color: #ffffff;
                .label {
                    padding-left: 40px;
                    flex-shrink: 0;
                    width: 160px;
                    margin-right: 47px;
                    color: #666;
                }
            }
            .line {
                width: 670px;
                height: 1px;
                background: #EEEEEE;
            }
        }

        .error-info {
            margin-top: 10px;
            text-align: center;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: #ff3446;
        }
    }
    .help {
        padding: 0px 40px;
        display: block;
        margin-top: 16px;
        margin-bottom: 55px;
        color: #8eb2d8;
        font-size: 22px;
    }
    .next-step {
        width: 650px;
        position: fixed;
        bottom:70px;
        left:50px;
    }
    .detention-dialog {
        .detention-content {
            width: 620px;
            background: rgba(255, 255, 255, 1);
            border-radius: 30px;
            overflow: hidden;
            .header {
                margin: 0px 0 45px;
                font-size: 36px;
                font-weight: 500;
                font-family: PingFangSC-Medium, PingFang SC;
                color: rgba(51, 51, 51, 1);
                line-height: 50px;
                text-align: center;
            }

            .body {
                li {
                    height: 110px;
                    line-height: 110px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 30px;
                    color: #999;
                    text-align: center;
                    border-bottom: 1px solid #eee;
                    &:first-child {
                        border-top: 1px solid #eee;
                    }
                }
            }

            .footer {
                display: block;
                margin: 55px auto;
                border: 0px solid transparent;
                font-family: PingFangSC-Medium, PingFang SC;
                font-size: 36px;
                font-weight: 600;
                color: #ff4633;
                text-align: center;
                -webkit-appearance: none;
                outline: none;
                background-color: #ffffff;
            }
        }
    }

    .activity-dialog {
        .activity-content {
            padding: 0 60px;
            padding-top: 42px;
            padding-bottom: 42px;

            .slogan {
                height: 42px;

                img {
                    height: 100%;
                    width: unset;
                }
            }

            .text {
                font-size: 32px;
                font-family: PingFangSC-Regular,PingFang SC;
                color: @fc1;
                font-weight: 400;
                margin-top: 43px;

                
            }

            p {
                em {
                    font-style: normal;
                    color: @theme;
                }
            }

            .description {
                width: 500px;
                height: 130px;
                background-color: #FFF0F0;
                padding: 29px 0;
                border-radius: 16px;
                margin-top: 100px;
                padding-left: 141px;
                position: relative;

                .desc-image {
                    height: 160px;
                    width: 116px;
                    background-image: url(../../images/img_ren@2x.png);
                    position: absolute;
                    left: 30px;
                    bottom: 0px;
                    background-size: 100% 100%;
                }

                p {
                    font-size: 24px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: @fc2;
                    line-height: 1.6em;
                }
            }

            .continue-btn {
                width: 440px;
                margin: 0 auto;
                height: 80px;
                line-height: 80px;
                font-size: 36px;
                font-weight: 600;
                margin-top: 70px;
            }

            .giveup-btn {
                height: 40px;
                font-size: 28px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                line-height: 40px;
                color: @fc3;
                text-decoration: underline;
                text-align: center;
                margin-top: 22px;
            }
        }

        .activity-template-content {
            width: 620px;
            height: 750px;
            background-size: contain;
            position: relative;

            .button-group {
                position: absolute;
                bottom: 48px;
                left: 50%;
                transform: translateX(-50%);

                .continue-btn {
                    width: 440px;
                    margin: 0 auto;
                    height: 80px;
                    line-height: 80px;
                    font-size: 36px;
                    font-weight: 600;
                    margin-top: 70px;
                }

                .giveup-btn {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    line-height: 40px;
                    color: @fc3;
                    text-decoration: underline;
                    text-align: center;
                    margin-top: 22px;
                }
            }
        }
    }
}
</style>